/**
 * Action types.
 * @module constants/ActionTypes
 */

export const SET_ISPRINT = 'SET_ISPRINT';
export const SET_PRINT_LOADING = 'SET_PRINT_LOADING';
export const GET_NAVIGATION_SETTINGS = 'GET_NAVIGATION_SETTINGS';
